<template>
    <Page>
        <div class="home">
            <main>
                <Overlay :image="config.HOME_BACKGROUND || config.HOME_BACKGROUND_MOBILE" dimmed/>
                <img :src="config.HOME_LOGO"/>
                <div class="text">
                    <h2>{{ config.HOME_TITLE }}</h2>
                    <h4 v-if="config.HOME_SUBTITLE">
                        {{ config.HOME_SUBTITLE }}
                    </h4>
                </div>
                <div v-if="showHomeSteps" class="steps">
                    <div v-for="(step, index) in homeSteps" :key="index" class="step">
                        <h2 class="number" :style="numberStyles">
                            {{ index + 1 }}
                        </h2>
                        <h3 :style="configStyles.primary.text">
                            {{ step.title }}
                        </h3>
                        <p>{{ step.description }}</p>
                    </div>
                </div>
                <Button :color="config.COLOR_PRIMARY" @click="onLogin">
                    {{ config.HOME_CTA }}
                </Button>
            </main>
        </div>
    </Page>
</template>
<script>
import contrast from 'contrast';

import { SolutionConsumer, UserConsumer, CoreConsumer } from '../../mixins';
import { Page } from '../../components/desktop';

export default {
    name: 'Home',
    components: { Page },
    mixins: [SolutionConsumer, UserConsumer, CoreConsumer],
    computed: {
        numberStyles () {
            return {
                background: this.config.COLOR_SECONDARY,
                color: contrast(this.config.COLOR_SECONDARY) === 'light' ? '#000' : '#fff',
            };
        },
    },
    methods: {
        onLogin () {
            this.login();
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

.home {
    display: flex;
    flex-grow: 1;

    > main {
        flex: 1 1 auto;
        position: relative;
        display: grid;
        gap: 40px;
        padding: 40px;
        place-items: center;
        justify-content: stretch;
        align-content: center;
        grid-auto-rows: min-content;
        color: $white;

        > img {
            max-height: 100px;
        }

        > .text {
            text-align: center;
            text-shadow: 0 6px 6px rgba($black, .2);

            > h2, > h4 {
                color: $white;
            }
        }

        > .steps {
            display: grid;
            grid-template-columns: repeat(auto-fit, 250px);
            gap: 40px;
            justify-content: center;
            width: 100%;

            > .step {
                text-align: center;
                padding: 20px;
                border-radius: 6px;
                background-color: rgba($white, .9);
                box-shadow: 8px 8px 24px 0 rgba($black, .2);
                backdrop-filter: blur(4px);

                > .number {
                    @include square(45px);
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0;
                    border-radius: 50%;
                    font-size: 25px;
                    line-height: 1em;
                }

                > p {
                    font-size: 14px;
                    font-weight: bold;
                    line-height: 1.8;
                    color: $grey;
                }
            }
        }
    }

    > aside {
        @include flex-vertical();
        width: 0;
        flex: 0 0 auto;
        overflow: hidden;
        transition: all .2s ease-in-out;
    }

    &.open {
        > aside {
            width: 350px;
        }
    }
}
</style>
